module.exports = __webpack_public_path__ + "static/about-us-23-8ec6beced33aebad9386876d86918e80.jpg";